import apiStores from '@/api/stores'

const state = {
  isLoading: false,
  store: null,
  validationErrors: null,
  isSubmitting: false,
}

export const mutationTypes = {
  updateStoresStart: '[update stores] updateStoresStart',
  updateStoresSuccess: '[update stores] updateStoresSuccess',
  updateStoresFailure: '[update stores] updateStoresFailure',

  getStoresStart: '[update stores] getStoresStart',
  getStoresSuccess: '[update stores] getStoresSuccess',
  getStoresFailure: '[update stores] getStoresFailure',
}

export const actionType = {
  updateStores: '[update stores] updateStores',
  getStores: '[update stores] getStores',
}

const mutations = {
  [mutationTypes.updateStoresStart](state) {
    state.isSubmitting = true
    state.validationErrors = null
    state.store = null
  },

  [mutationTypes.updateStoresSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateStoresFailure](state, payload) {
    state.isSubmitting = false
    state.validationErrors = payload
  },

  [mutationTypes.getStoresStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },

  [mutationTypes.getStoresSuccess](state, payload) {
    state.isLoading = false
    state.store = payload
  },

  [mutationTypes.getStoresFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },
}

const actions = {
  [actionType.getStores](context, {id}) {
    context.commit(mutationTypes.getStoresStart)
    return new Promise((resolve) => {
      apiStores
        .getStore(id)
        .then((response) => {
          context.commit(mutationTypes.getStoresSuccess, response.data)
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getStoresFailure,
            result.response.data.errors
          )
        })
    })
  },

  [actionType.updateStores](context, sport) {
    context.commit(mutationTypes.updateStoresStart)
    return new Promise((resolve) => {
      apiStores
        .updateStores(sport)
        .then((response) => {
          context.commit(mutationTypes.updateStoresSuccess, response.data)
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.updateStoresFailure,
            result.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
